/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-06 10:31:42
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-06 11:03:00
 */
import { Input, Button } from 'antd'
import React from 'react'
import { removeCookie, setCookie } from 'src/utils/checkCookie'

let globalurl = global.url
export default class ConfigPage extends React.Component {



    render() {

        return (<div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>问答：</span><Input ref={ref=>this.wd=ref} defaultValue={globalurl.wd} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>培训：</span><Input ref={ref=>this.px=ref} defaultValue={globalurl.px} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>新闻公告</span><Input ref={ref=>this.news=ref} defaultValue={globalurl.news} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>即时通信</span><Input ref={ref=>this.im=ref} defaultValue={globalurl.im} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>系统管理</span><Input ref={ref=>this.sys=ref} defaultValue={globalurl.sys} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>直播:</span><Input ref={ref=>this.live=ref} defaultValue={globalurl.live} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>云盘:</span><Input ref={ref=>this.cd=ref} defaultValue={globalurl.cd} style={{ float: 'left', width: 400 }}></Input></div>
            <div style={{width:'100%',height:44}}><span style={{ float: 'left',marginLeft:20, lineHeight: '30px', fontSize: 18 }}>订单:</span><Input ref={ref=>this.order=ref} defaultValue={globalurl.order} style={{ float: 'left', width: 400 }}></Input></div>



            <div>
                <Button onClick={()=>{
                    setCookie('qa-center-url',this.wd.state.value)
                    setCookie('online-school-url',this.px.state.value)
                    setCookie('news-announcement-url',this.news.state.value)
                    setCookie('instant-messaging-url',this.im.state.value)
                    setCookie('system-manager-url',this.sys.state.value)
                    setCookie('live-stream-url',this.live.state.value)
                    setCookie('clouddisk-url',this.cd.state.value)
                    setCookie('order-service-url',this.order.state.value)
                    window.location.reload()
                }}>保存</Button>
                <Button onClick={()=>{
                    removeCookie('qa-center-url')
                    removeCookie('online-school-url')
                    removeCookie('news-announcement-url')
                    removeCookie('instant-messaging-url')
                    removeCookie('system-manager-url')
                    removeCookie('live-stream-url')
                    removeCookie('clouddisk-url')
                    removeCookie('order-service-url')
                    window.location.reload()
                }}>恢复默认</Button>
            </div>

        </div>)
    }
}